module.exports = __webpack_public_path__ + "static/media/bicycle.f44c8a0d.png";